export default __webpack_public_path__ + "static/media/products-carrousel.87696893.svg";